// Angular
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'kt-quick-action-result',
	templateUrl: './quick-action-result.component.html',
})
export class QuickActionResultComponent implements OnInit, AfterViewInit {
	// Public properties

	// Set icon class name
	@Input() icon: string = 'flaticon2-gear';

	@Input() iconType: '' | 'warning';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() gridNavSkin: 'light' | 'dark' = 'light';

	@Input() offcanvas: boolean = false;

	data: any[] = [];
	/**
	 * Component constructor
	 */
	constructor() {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * After view init
	 */
	ngAfterViewInit(): void {
	}

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.data = [{
			'icon': './assets/media/icons/svg/Shopping/Euro.svg',
			'title': 'Accounting',
			'desc': 'eCommerce'
		}, {
			'icon': './assets/media/icons/svg/Communication/Mail-attachment.svg',
			'title': 'Administration',
			'desc': 'Console'
		}, {
			'icon': './assets/media/icons/svg/Shopping/Box%232.svg',
			'title': 'Projects',
			'desc': 'Pending Tasks'
		}, {
			'icon': './assets/media/icons/svg/Communication/Group.svg',
			'title': 'Customers',
			'desc': 'Latest cases'
		}]
	}

	onSVGInserted(svg) {
		svg.classList.add('kt-svg-icon', 'kt-svg-icon--success', 'kt-svg-icon--lg');
	}

	getIndex() {
		var lst = [];
		for (var i = 0; i < this.data.length; i++) {
			if (i % 2 == 0)
				lst.push(i);
		}
		return lst;
	}
}
